export const display = (value) => {
    if (value) {
        return value;
    } else {
        return ' - ';
    }
};

export const eitherDisplayOrRemove = (value) => {
    // IF VALUE IS TRUTHY  DISPLAY VALUE
    if (value) {
        return value;
        // IF VALUE IS FALSY ( NULL OR UNDEFINED OR EMPTY STRING OR 0 OR FALSE)  DISPLAY EMPTY STRING
    } else {
        return ' ';
    }
};

export const displayFormatted = (oldText, newText) => {
    if (oldText) {
        return newText;
    } else {
        return '';
    }
};

export const format = {
    replace: (oldText, newText) => newText,
    autoFormat: (oldtext) => {
        const words = oldtext.replaceAll('_', ' ');
        const cap = words[0].toUpperCase() + words.slice(1);
        return cap;
    },
};
export const formatCurrencyWithDecimal = (amount, currency = 'USD') => {
    // If the amount is a string and ends with a dot, return it as-is
    if (typeof amount === 'string' && amount.trim().endsWith('.')) {
        return amount;
    }

    // If not a number or empty, return empty string
    if (amount === '' || isNaN(Number(amount))) {
        return '';
    }

    const numberAmount = Number(amount);

    const options = {
        style: 'currency',
        currency,
        minimumFractionDigits: numberAmount % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2,
    };

    return new Intl.NumberFormat('en-US', options).format(numberAmount);
};

export const formatCurrency = (amount, currency = 'USD') => {
    const value = typeof amount === 'string' ? Number(amount.replace(/,/g, '')) : amount;

    const options = {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    };

    return new Intl.NumberFormat('en-US', options).format(value);
};

export const formatCurrencyWithoutRoundoff = (value, currency = 'USD', includeDollarSymbol = true) => {
    const truncateAmount = (val) => {
        if (val === null || val === undefined) return 0;

        // Convert to string to avoid floating point issues
        const str = String(val);

        if (!str.includes('.')) return Number(str);

        const [intPart, decPart] = str.split('.');

        // Take only first 2 digits without rounding
        const truncatedDecimal = decPart.slice(0, 2);

        return Number(`${intPart}.${truncatedDecimal}`);
    };

    const truncatedValue = truncateAmount(value);
    if (truncatedValue === 0) return '-';

    const formatted = new Intl.NumberFormat('en-US', {
        ...(includeDollarSymbol ? { style: 'currency', currency, currencyDisplay: 'narrowSymbol' } : {}),
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(truncatedValue);

    return formatted;
};

export const parseCurrency = (value) => {
    if (!value) return '';
    const cleaned = value.replace(/[^0-9.]/g, '');

    // Allow only one decimal point
    const parts = cleaned.split('.');
    if (parts.length > 2) {
        return parts[0] + '.' + parts[1]; // Drop additional dots
    }

    return cleaned;
};

export const truncateText = (text, maxLength) => {
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
};

export const generateUniqueKey = () => {
    return Math.random().toString(36).substring(2, 15);
};

export const isObjectEmpty = (obj) => {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
};

export const toggleClassName = (currentClassName, toggleClassName, condition) => {
    return condition ? `${currentClassName} ${toggleClassName}` : currentClassName;
};

export const deepCopy = (obj) => {
    return JSON.parse(JSON.stringify(obj));
};

export const filterArrayByProperty = (array, propertyName, filterValue) => {
    return array.filter((item) => item[propertyName] === filterValue);
};

export const customisePartName = (name) => {
    if (name == 'oem') return 'OEM';
    if (name == 'after_market') return 'After Market';
    if (name == 'used') return 'Used';
    if (name == 'oes') return 'OES';
};
